interface propLoad {
  loadType?: "flutuant" | "static";
}

const LoadingBox = (props: propLoad) => {
  const loadingType = props?.loadType;
  let cssType = "";

  if (loadingType === "flutuant") {
    cssType = "loadingBox";
  }

  return (
    <div className={cssType}>
      <div className="loading-spinner" />
      <p style={{ textAlign: "center" }}>Carregando...</p>
    </div>
  );
};
export default LoadingBox;
